<template>
  <div>
    <div id="body">
      <div class="wrapper">
        <div class="usercenter">
          <UserLeftGuid :menuActive="'/user/upload'"></UserLeftGuid>

          <div class="main">
            <div class="title">
              <h2>
                <svg
                  t="1653550397397"
                  viewBox="0 0 1051 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2209"
                  width="64"
                  height="64"
                >
                  <path
                    d="M524.95099812 686.98366625a40.42105219 40.42105219 0 0 0 40.30490063-40.30490063V155.23775l169.00181437 169.00181437a41.23411969 41.23411969 0 0 0 56.91470063 0 40.30490063 40.30490063 0 0 0 0-56.91470062L577.91651563 53.72050812a74.33756813 74.33756813 0 0 0-104.53720501 1e-8L258.845735 267.32486375a40.18874813 40.18874813 0 0 0 56.91470063 56.91470063L484.994555 155.23775v491.44101563a40.30490063 40.30490063 0 0 0 39.95644313 40.30490062z"
                    p-id="2210"
                  ></path>
                  <path
                    d="M841.93103469 141.76406563a40.30490063 40.30490063 0 1 0 0 80.49364781A95.70961875 95.70961875 0 0 1 937.98911094 317.85117969v498.06170625a95.70961875 95.70961875 0 0 1-95.59346625 95.59346625H208.08711406a95.70961875 95.70961875 0 0 1-95.59346625-95.59346625V317.85117969a95.70961875 95.70961875 0 0 1 95.59346625-95.59346625 40.30490063 40.30490063 0 0 0 0-80.49364782A176.31941906 176.31941906 0 0 0 32 317.85117969v498.06170625a176.31941906 176.31941906 0 0 0 176.08711406 176.08711406h633.84392063a176.31941906 176.31941906 0 0 0 176.08711406-176.08711406V317.85117969A176.31941906 176.31941906 0 0 0 841.93103469 141.76406563z"
                    p-id="2211"
                  ></path>
                </svg>
                我的上传
              </h2>
            </div>
            <div class="box">
              <div class="list-top">
                <div class="list-page-total">
                  共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                </div>
                <div class="list-search">
                  <el-input placeholder="" size="small" v-model="searchTitle">
                    <el-button
                      slot="append"
                      size="small"
                      type="primary"
                      @click="handleSearch"
                    >
                      查询
                    </el-button>
                  </el-input>
                </div>
              </div>

              <div class="box-content" v-loading="loading">
                <el-table :data="tableData" style="width: 100%">
                  <el-table-column
                    align="center"
                    label="序号"
                    type="index"
                    width="80"
                  >
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="标题"
                    min-width=""
                    prop="eventTitle"
                  >
                  </el-table-column>
                  <el-table-column align="center" label="时间" width="250">
                    <template #default="scope">
                      {{ dateFormat(scope.row.createTime) }}
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" width="250">
                    <template #default="scope">
                      <el-button
                        type="text"
                        size="mini"
                        icon="el-icon-view"
                        @click="handleView(scope.row.dataId)"
                        >查看
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="list-bottom">
                  <div class="list-page-total">
                    共 {{ total }} 条 第{{ pageIndex }}/{{ pageCount }}页
                  </div>
                  <div class="list-page">
                    <el-pagination
                      :current-page="pageIndex"
                      :page-size="pageSize"
                      layout="prev,pager,next,jumper"
                      :total="total"
                      @current-change="handleCurrentPageChange"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserLeftGuid from "../../components/user/left_guid.vue";
import { axiosRequest, axiosOptions } from "../../util/request";
import moment from "moment";

export default {
  components: { UserLeftGuid },
  data() {
    return {
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      pageCount: 0,
      total: 0,
      loading: false,
      searchTitle: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    dateFormat(cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    getList() {
      this.loading = true;

      axiosRequest(
        "/user/upload-list",
        {
          title: this.searchTitle,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.total = res.data.data.total;
            this.pageCount = res.data.data.pages;
            this.tableData = res.data.data.records;
          }

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCurrentPageChange(currentPage) {
      this.pageIndex = currentPage;
      this.getList();
    },
    handleSearch() {
      this.pageIndex = 1;
      this.getList();
    },
    handleView(id) {
      if (id) {
        this.$router.push({ name: "case_details", params: { id: id } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "~@/assets/css/usercenter.scss";
</style>
